export class RangeError extends Error {
  value: string;

  min: number;

  max: number;

  constructor(message: string, value: string, min: number, max: number) {
    super(message);
    this.name = 'RangeError';
    this.value = value;
    this.min = min;
    this.max = max;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }
}
